import Splide from "@splidejs/splide";


document.addEventListener( 'DOMContentLoaded', function() {
  const bannerItems = document.querySelectorAll('.js--main-banner');

  if (bannerItems.length) {
    bannerItems.forEach((item) => {
      var splide = new Splide( item, {
        perPage: 1,
        width: '100%',
        pagination : false,
        arrows: false,
        direction: "ttb",
        height: '424px',
        autoHeight: false,
        breakpoints: {
          1280: {
            perPage: 1,
            direction: "ltr",
            pagination : true,
            arrows: false,
            autoHeight: true,
            width: '100%',
            height: '100%',
          },
        },
      } );

    var thumbnails = item.parentElement.querySelectorAll( '.thumbnail' );

    var current;

      for ( var i = 0; i < thumbnails.length; i++ ) {
        initThumbnail( thumbnails[ i ], i );
      }

      function initThumbnail( thumbnail, index ) {
        thumbnail.addEventListener( 'click', function () {
          splide.go( index );
        } );
      }

      splide.on( 'mounted move', function () {
        var thumbnail = thumbnails[ splide.index ];

        if ( thumbnail ) {
          if ( current ) {
            current.classList.remove( 'active' );
          }

          thumbnail.classList.add( 'active' );
          current = thumbnail;
        }
      } );


      splide.mount();
    });

  }

} );
